export default "__VITE_ASSET__Dv68F1LM__"